import React from "react";
import './registry.css';

function Registry() {
    return(

    <section className="registry-wrapper" id="Registry">
    <h1>Start Growing With Us!</h1>
    <p>Start patnering with us as early as you can so you can get more benefit from your business.</p>
    <p>Register now for free</p>
    <button>Register</button>
    </section>

    )
}

export default Registry;